import React, { useCallback, useMemo, useState } from "react";
import axios from "axios";
import apiUrl from "../Apiurl";
import prodVuoto from "../prodottoVuoto";
import ModaArticoliBrowser from "./ModaArticoliBrowser";
import ModificaProdottiNEW from "../modificaProdotti/ModificaProdottiNEW";

const normalizeRawPayload = (rawPayload) => {
  if (rawPayload == null) {
    return null;
  }
  if (typeof rawPayload === "object") {
    return rawPayload;
  }
  if (typeof rawPayload === "string") {
    try {
      return JSON.parse(rawPayload);
    } catch {
      return rawPayload;
    }
  }
  return null;
};

function ModaArticoliWorkspace({
  token,
  utente,
  mobile = false,
  temaColori = "rootTema",
  setProductFunction,
  listaNomiProdotto,
}) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedModaArticolo, setSelectedModaArticolo] = useState(null);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [productError, setProductError] = useState("");
  const [refreshToken, setRefreshToken] = useState(0);

  const handleCloseEditor = useCallback(() => {
    setSelectedProduct(null);
    setSelectedModaArticolo(null);
    setProductFunction(prodVuoto);
    setRefreshToken((value) => value + 1);
  }, [setProductFunction]);

  const handleOpenProduct = useCallback(
    async ({ codVS, rawPayload, row }) => {
      if (!token) {
        setProductError("Token non disponibile per il caricamento prodotto.");
        return;
      }
      if (!codVS) {
        setProductError("Codice VS non valido.");
        return;
      }
      setLoadingProduct(true);
      setProductError("");
      const normalizedRawPayload = normalizeRawPayload(rawPayload);
      const payload = {
        codiceVS: codVS,
        sorgenteModa: row ?? null,
      };
      if (normalizedRawPayload) {
        payload.raw_payload = normalizedRawPayload;
      }
      try {
        const response = await axios.post(
          apiUrl + "/prodotti/prodotto/showORcreateIDPS4",
          payload,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        const lista = Array.isArray(response?.data) ? response.data : [];
        const prodottoSelezionato = lista.length > 0 ? lista[0] : prodVuoto;
        setProductFunction(prodottoSelezionato);
        setSelectedModaArticolo(row ?? null);
        setSelectedProduct(prodottoSelezionato);
      } catch (error) {
        console.error("Errore showORcreateIDPS4:", error);
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Impossibile aprire il prodotto selezionato.";
        setProductError(message);
      } finally {
        setLoadingProduct(false);
      }
    },
    [token, setProductFunction]
  );

  const overlayContent = useMemo(() => {
    if (!selectedProduct) {
      return null;
    }
    return (
      <div className="fixed top-0 left-0 w-100 h-100 flex flex-column z-999 bg-white">
        <ModificaProdottiNEW
          prodotto={selectedProduct}
          modaArticoloIniziale={selectedModaArticolo}
          setProductFunction={setProductFunction}
          utente={utente}
          listaNomiProdotto={listaNomiProdotto}
          onClose={handleCloseEditor}
        />
      </div>
    );
  }, [
    selectedProduct,
    selectedModaArticolo,
    handleCloseEditor,
    setProductFunction,
    utente,
    listaNomiProdotto,
  ]);

  return (
    <div className={`${temaColori} relative`}>
      {productError && (
        <div className="pa3 bg-washed-red dark-red">{productError}</div>
      )}
      <ModaArticoliBrowser
        token={token}
        utente={utente}
        mobile={mobile}
        temaColori={temaColori}
        onOpenProduct={handleOpenProduct}
        refreshToken={refreshToken}
      />
      {loadingProduct && (
        <div className="fixed top-0 left-0 w-100 h-100 flex items-center justify-center bg-white z-999">
          Caricamento prodotto in corso...
        </div>
      )}
      {overlayContent}
    </div>
  );
}

export default ModaArticoliWorkspace;
